import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { TextField, InputAdornment, Typography } from '@mui/material';
import { truncateString } from '../../../utils/truncateString';
import Stack from '@mui/material/Stack';
import { useUpdateBundleItem } from '../../../hooks/inventory/useUpdateBundleItem';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';

export default function BundleItemQuantityForm({ successCallback = null, item = null, open, onClose }) {

    const { t } = useTranslation('common'); 

    const [quantity, setQuantity] = React.useState(item ? item.quantity : "");

    const { update } = useUpdateBundleItem(successCallback);

    const { showSnackbar } = useSnackbar();

    React.useEffect(() => {
        // reset field when there are changes (e.g. when opening edit)
        setQuantity(item ? item.quantity : "");
    }, [item, open]);

    const handleSave = async () => {
        if (!quantity) {
            showSnackbar(t('inventory.bundle_items.messages.quantity_required'), "warning");
            return;
        }

        try 
        {
          await update(item.id, { 
            quantity: quantity
          });
          showSnackbar(t('inventory.bundle_items.messages.update_success'), "success");
          handleCancel();

          setQuantity("");
        } catch (err) {
          showSnackbar(t('inventory.bundle_items.messages.save_fail'), "error");
        }

    };

    const handleCancel = () => {
        setQuantity("");
        onClose();
    };

    return (
        <>
        <Dialog onClose={handleCancel} open={open} disableRestoreFocus>

        <DialogTitle>Change Quantity</DialogTitle>

        <DialogContent dividers>
            <Stack spacing={1}  alignItems="center">
              <Typography variant='h6'>
                {item.inventoryItem.name}
              </Typography>
              <TextField
                fullWidth
                value={quantity}
                onChange={(e) => {
                  const val = e.target.value; // keep raw string
                  setQuantity(val);
                }}
                size="small"
                variant="outlined"
                type="number"
                placeholder="Qty"
                sx={{ width: 150, mr: 1 }}
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <Typography variant='body2'>
                        {truncateString(item.inventoryItem.uom, 6)}
                        </Typography>
                      </InputAdornment>
                    ),
                  },
                }}
              />
            </Stack>
        </DialogContent>

        <DialogActions>
            <Button onClick={handleSave}>
                Save
            </Button>
            <Button onClick={handleCancel}>Cancel</Button>
        </DialogActions>
        </Dialog>
        </>
    );
}